import React from 'react';
import ReactDOM from 'react-dom';
import FormState from './store/formState';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import './components/CustomInput/Inputypes/Article/FroalaStyles'

Sentry.init({
  dsn: "https://d2e85aac0b6642dab965a66e65095708@o193292.ingest.sentry.io/6087639",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});


ReactDOM.render(
  <React.StrictMode>
    <FormState>
      <App />
    </FormState>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
